import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { SessionStorageService } from '../services/session-storage.service';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';

export const tokenExpiredGuard: CanActivateFn = (route, state) => {
  const storage = inject(SessionStorageService);
  const authService = inject(AuthService);
  const router = inject(Router);

  // Valida expiração do token
  const isTokenExpired = (): boolean => {
    const jwtPayload = storage.getInfoFromToken();
    const expirationDate = jwtPayload.exp * 1000;
    const currentTime = Date.now();

    return currentTime > expirationDate;
  };

  if (isTokenExpired()) {
    authService.logOut();
    router.navigateByUrl('login');
    return false;
  }

  return true;
};
